/**
 * formatHostname.tsx - Hostname Formatting Utility
 */

export function sublessHostname() {
    var sublessHostname = ""

    if (window.location.hostname.includes("co.uk")) {
        if (window.location.hostname.split(".").length > 3) {
            sublessHostname = window.location.hostname.split(".").slice(1).join(".")
        } else {
            sublessHostname = (window.location.hostname)
        }
    } else {
        if (window.location.hostname.split(".").length > 2) {
            sublessHostname = window.location.hostname.split(".").slice(1).join(".")
        } else {
            sublessHostname = (window.location.hostname)
        }
    }

    return sublessHostname
}
